import { Subject } from 'types/subject';

/**
 * Calculates the total credits points for many Subjects.
 * @export
 * @param {Subject[]} subjects
 * @return {*}  {number}
 */
export function getTotalCreditPoints(subjects: Subject[]): number {
  return subjects.reduce<number>((totalCP, subject) => totalCP + subject.creditPoints, 0);
}
